import React, { Component } from 'react';

export default class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileView: window.innerWidth < 768 // Check if the initial window width is below 768px
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  handleWindowResize = () => {
    const isMobileView = window.innerWidth < 768;
    if (isMobileView !== this.state.isMobileView) {
      this.setState({ isMobileView });
    }
  };

  render() {
    const { isMobileView } = this.state;

    return (
      <section id="plans" style={{ textAlign: 'center' }}>
        <div className="row Prices">
          <div className="twelve columns">
            <h1>
              <span>Prices</span>
            </h1>
          </div>
        </div>

        <div className="row PlanContainer">
          <div className="four columns">
            <h2>Base</h2>
            <p>Monitoring & Management of Physical & Cloud Devices</p>
            <p>Domain and Software as a Service Management</p>
            <p>1 Solution build project at a time</p>
            <p>Basic IT Support</p>

            {/* Show price details only on mobile or when screen width is reduced */}
            {isMobileView && (
              <div className="PlanPriceDetailsMobile">
                <div>
                  <span className="PlanPrice">Monthly Base: $699</span>
                </div>
                <div>
                  <span className="PlanPrice">Hourly Rate: $25 per hour</span> 
                </div>
                <br></br>
              </div>
              
            )}
          </div>

          <div className="four columns">
            <h2>Pro</h2>
            <p>Everything from Base Plan</p>
            <p>3 Solution build projects at a time</p>
            <p>Advanced Threat Protection from multiple surface levels</p>

            {/* Show price details only on mobile or when screen width is reduced */}
            {isMobileView && (
              <div className="PlanPriceDetailsMobile">
                <div>
                  <span className="PlanPrice">Monthly Base: $1000</span>
                </div>
                <div>
                  <span className="PlanPrice">Hourly Rate: $16 per hour</span> 
                </div>
                <br></br>
              </div>
            )}
          </div>

          <div className="four columns">
            <h2>Business</h2>
            <p>Everything from Pro Plan</p>
            <p>5 Solution build projects at a time</p>
            <p>24/7 IT Support</p>

            {/* Show price details only on mobile or when screen width is reduced */}
            {isMobileView && (
              <div className="PlanPriceDetailsMobile">
                <div>
                  <span className="PlanPrice">Monthly Base: $1249</span>
                </div>
                <div>
                  <span className="PlanPrice">Hourly Rate: $12 per hour</span> 
                </div>
                <br></br>
              </div>
            )}
          </div>
        </div>

        {/* Show price details on desktop */}
        {!isMobileView && (
          <div className="row PlanPriceDetailsDesktop">
            <div className="four columns">
              <div>
                <span className="PlanPrice">Monthly Base: $699</span>
              </div>
              <div>
                <span className="PlanPrice">Hourly Rate: $25 per hour</span> 
              </div>
            </div>
            <div className="four columns">
              <div>
                <span className="PlanPrice">Monthly Base: $1000</span> 
              </div>
              <div>
                <span className="PlanPrice">Hourly Rate: $16 per hour</span> 
              </div>
            </div>
            <div className="four columns">
              <div>
                <span className="PlanPrice">Monthly Base: $1250</span> 
              </div>
              <div>
                <span className="PlanPrice">Hourly Rate: $12 per hour</span> 
              </div>
            </div>
          </div>
        )}
      </section>
    );
  }
}
